export default [
    {
        path:'user.password',
        name:'user.password',
        component: r => require.ensure([], () => r(require('./password.vue')), 'user.password'),
    },
]